import { ClientCreation } from '@Arti-zen/package-backoffice'
import { CheckCircle } from '@mui/icons-material'
import Info from 'components/Info'
import { InfoRedStyle, Row, ValidButton } from 'modules/product/ProductListTable.definitionFields'
import { Theme } from 'theme/theme'
import CancelIcon from '@mui/icons-material/Cancel'

type TProps = {
  errorMessage: string
  correctClient: (corrections: Partial<ClientCreation>) => void
}

export default function IsProfessionalErrorTable({ errorMessage, correctClient }: TProps) {
  const chooseIsProfessional = (e: React.MouseEvent, bool: boolean) => {
    e.preventDefault()
    e.stopPropagation()
    correctClient({ isProfessional: bool })
  }

  return (
    <Row>
      <ValidButton onClick={(event) => chooseIsProfessional(event, true)} style={{ color: 'white' }}>
        <CheckCircle color="inherit" />
      </ValidButton>
      <ValidButton
        onClick={(event) => chooseIsProfessional(event, false)}
        style={{ color: 'white', backgroundColor: Theme.colors.greenArtizen }}
      >
        <CancelIcon color="inherit" />
      </ValidButton>
      <Info text={errorMessage} style={InfoRedStyle} />
    </Row>
  )
}
